// TODO: remove if not needed since default Ant Design Checkbox already has correct styles
import React from 'react'
import { Checkbox as AntCheckbox } from 'antd'
import PropTypes from 'prop-types'

// styles
import './checkbox.scss';

const Checkbox = ({
  id, // not an antd Checkbox prop
  label, // TODO: use children instead
  className,
  children,
  ...otherProps // defaultChecked, onChange (evt.target.checked)
}) => {
  const classNames = `prime-checkbox${className ? ' ' + className : ''}`

  return (
    <AntCheckbox
      id={id}
      className={classNames}
      {...otherProps}
    >
      {children || label}
    </AntCheckbox>
  )
}

Checkbox.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  defaultChecked: PropTypes.bool,
  checked: PropTypes.bool, // controlled component
}

export default Checkbox